import { Box } from "@mui/system";
import React from "react";
import { useSelector } from "react-redux";
import NavSidebar from "./NavSidebar";
import { Outlet } from "react-router-dom";
import "../index.css";
import { CircularProgress, createTheme, ThemeProvider } from "@mui/material";
import useProfile from "../hooks/useProfile";

const Main = () => {
  const [userData] = useProfile();



  const open = useSelector((state) => state.NavSidebar.open);
  const vw = Math.max(document.clientWidth || 0, window.innerWidth || 0);

  const theme = createTheme({
    typography: {
      fontFamily: "'Poppins', sans-serif",
    },
  });
  return (
    <>
      {!userData?.id && (
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            height: "100vh",
          }}
        >
          <CircularProgress />
        </div>
      )}
      {userData?.id && (
        <ThemeProvider theme={theme}>
          <div>
            <NavSidebar />
            <Box
              style={{
                minHeight: "calc(100vh - 70px)",
                backgroundColor: "#f6f9fc",
              }}
              className={vw > 700 && open ? "content-open" : "content-close"}
            >
              <Outlet />
            </Box>
          </div>
        </ThemeProvider>
      )}
    </>
  );
};

export default Main;
